import React ,{useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { dateFormat,utcDateTimeWithTimeZoneWithFormat, compareDateWithCurrent, dateFormatAccToTimeZone } from "../../../services/Util";
import BidNeedMoreTime from "./BidNeedMoreTime";
import Constants from "../../../Constants";
import $ from "jquery";
import { WatchIcon } from "../../../AppIcons";
export default function UserTaskList(prop) {
const projectResource = prop.projectDetail.resource.projectResource
  
  const showBid = () => {
    prop.funct("bids");
  };
  
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const navigate = useNavigate();
  const getMyTaskLink = (task) => {
    var url = "/project";
    var urlLastPart = ''
    switch (task.type.originalEnum) {
      case "CONFIGURE_PROJECT_SOURCE" : 
      url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );
      case "REVIEW_BID_DUE_DATE" :
        return (
          <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('overView','')}}>
          {task.displayName}
          </button>
        );
      case "REVIEW_PROJECT_REQUEST":
        url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );
      case "CONFIGURE_PROJECT_WORKFLOW" : 
      url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );
      case "SELECT_WINNING_BID":
        return (
          <>
          <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('bids','')}}>
          {task.displayName}
        </button>
        {projectResource?.userCanAlterProject ?
        <button className="button-link linkFont80" onClick={(e)=>{prop.showPopup();document.body.classList.add("modal-open");}}>{'(Need more time?)'}</button> : ''}
        </>
        )

      case "RESPOND_TO_CUSTOMER_INTERNAL_PROJECT_REQUEST":
        return (
          <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('internalTranslator','')}}>
            {task.displayName}
            </button>
        );
      case "SUBMIT_TM_AND_CLOSE_PROJECT" : 
      return (
        <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('overView','')}}>
            {task.displayName}
            </button>
      );
      case "CUSTOM" :
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop()  
        if(task.project !== ''){
          return (
            <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('tasks',urlLastPart)}}>
            {task.displayName}
            </button>
          );
        }else{
          var newUrl = task.url.replace("#workspace", "/campaign");
          var taskId  = url.split("/").pop()  
          return (
            <Link className="linkFont100" onClick={(e)=>{e.preventDefault();navigate(newUrl,{state:{id:taskId}})}}>
              {task.displayName}
            </Link>)
        }
       

      case "RESPOND_TO_MACHINE_TRANSLATION_QUOTE":
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop()
        return (
            <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('machineTranslation',urlLastPart)}}>
            {task.displayName}
            </button>
        );

      case "RESPOND_TO_VENDOR_CHANGE_ORDER_BID":
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop()
        return (
          <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('changeOrder',urlLastPart);setTimeout(() => {$('button.active').trigger('focus')}, 300);}}>
            {task.displayName}
          </button>
        );

      case "RESPOND_TO_CUSTOMER_CHANGE_ORDER_REQUEST":
        url = `/${task?.url.substring(1)}`;
        urlLastPart = url.split("/").pop()
        return (
            <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('changeOrder',urlLastPart);setTimeout(() => {$('button.active').trigger('focus')}, 300);}}>
            {task.displayName}
          </button>
        );

      case "PROJECT_ACCEPT_CANCELLATION":
        return (
            <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('bids',urlLastPart)}}>
            {task.displayName}
          </button>
        );

      case "REVIEW_APPROVED_ASSET_NOTES":
        url = `/${task.url.substring(1)}`;
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
            {task.displayName}
          </Link>
        );

      case "REQUEST_BIDS_FOR_PROJECT":
        url = `/project/${task.project.id}`;
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
            {task.displayName}
          </Link>
        );

      case "REVIEW_PROJECT_ASSETS":
        url = `/${task?.url.substring(1)}`;
        var code = ''
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
            <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('overView',code)}}>
            {task.displayName}
          </button>
        );

      case "DELIVER_PROJECT_ASSETS":
        url = `/${task?.url.substring(1)}`;
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
            <button className="button-link linkFont100" onClick={(e) => {e.preventDefault();prop.showTabWithId('overView',code)}}>
            {task.displayName}
          </button>
        );

      case "REVISE_PROJECT_ASSETS":
        url = `/${task.url.substring(1)}`;
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
            {task.displayName}
          </Link>
        );

      case "ASSIGN_USERS_TO_GROUPS":
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/settings/user-management`)}}>
            {task.displayName}
          </Link>
        );

      default:
        return "";
    }
  };
  return (
    <>
      <div className="tabitem-list flex-center" key={prop?.id}>
        <div className="flex-center flex-width">
          <div className="date-tag flex-center">
            <strong>{dateFormat(prop?.task?.createdDate?.utcTimestamp, Constants.ONLY_DATE_FORMAT)}</strong>
            <span>{dateFormat(prop?.task?.createdDate?.utcTimestamp, Constants.ONLY_MONTH_FORMAT_NAME)}</span>
          </div>
          <div className="tabitem-text flex-center">
            {prop.use === "dashboard" ? (
              <>
                <strong>{getMyTaskLink(prop.task)}</strong>
                {prop.task.project !== "" ? (
                  <span style={{fontSize: "85.7142857143%"}}>
                    {prop.task.project?.name}{" "}
                    {prop.task.userGroup?.name !== ""
                      ? "(" + prop.task.userGroup?.name + ")"
                      : ""}
                  </span>
                ) : (
                  prop.task.projectRequest !== '' ?
                  <span style={{fontSize: "85.7142857143%"}}>
                    {prop.task.projectRequest?.name}{" "}
                    {prop.task.userGroup?.name !== ""
                      ? "(" + prop.task.userGroup?.name + ")"
                      : ""}
                  </span> : ''
                )}
              </>
            ) : (
              getMyTaskLink(prop.task)
            )}
          </div>
        </div>
        {prop.task.dueDate !== "" ? (
          <div className="assign-due flex-center" aria-label="due today">
            {WatchIcon}
            {compareDateWithCurrent(prop.task.dueDate, Constants.DATE_FORMAT)
              ? "Due Today"
              : prop.task.dueDate.date}
          </div>
        ) : (
          ""
        )}
      </div>
      
      
    </>
  );
}
